import { useNavigate } from "react-router-dom";
import {
  Briefcase,
  Camera,
  HardDrive,
  Images,
  LayoutDashboard,
  LogOut,
  Package,
  Settings,
  ShoppingCart,
  Users,
  Video,
} from "lucide-react";
import { Layout, type NavItem } from "@groot/shell/components/Layout";
import type { CommandGroupEntry } from "@groot/shell/components/CommandPalette";
import { useAuthStore } from "@groot/shell/store/auth";

const NAV_ITEMS: NavItem[] = [
  { name: "Dashboard", href: "/", icon: LayoutDashboard, exact: true },
  { name: "Customers", href: "/customers", icon: Users },
  { name: "Products", href: "/products", icon: Package },
  { name: "Orders", href: "/orders", icon: ShoppingCart },
  { name: "Photo Requests", href: "/photo-requests", icon: Camera },
  { name: "Moments", href: "/moment-requests", icon: Video },
  { name: "Print", href: "/print-batches", icon: Images },
];

const SYSTEM_ITEMS = [
  { name: "Storage", href: "/storage", icon: HardDrive },
  { name: "Jobs", href: "/jobs", icon: Briefcase },
  { name: "Settings", href: "/settings", icon: Settings },
];

/** The groot shell, configured with Riqah Design's navigation and palette. */
export function AppLayout() {
  const navigate = useNavigate();
  const logout = useAuthStore((state) => state.logout);

  const commandGroups: CommandGroupEntry[] = [
    {
      heading: "Business",
      items: NAV_ITEMS.map((item) => ({
        label: item.name,
        icon: typeof item.icon === "string" ? undefined : item.icon,
        onSelect: () => navigate(item.href),
      })),
    },
    {
      heading: "System",
      items: SYSTEM_ITEMS.map((item) => ({
        label: item.name,
        icon: item.icon,
        onSelect: () => navigate(item.href),
      })),
    },
    {
      heading: "Account",
      items: [
        {
          label: "Logout",
          icon: LogOut,
          variant: "destructive",
          onSelect: () => {
            logout();
            navigate("/login");
          },
        },
      ],
    },
  ];

  return <Layout navItems={NAV_ITEMS} commandGroups={commandGroups} />;
}
